module.exports = __webpack_public_path__ + "static/4-e4cdb14bf148f2846997a6be7ba648bd.woff2";